import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { RouterFacade } from '~/core/features'
import { EGuardSection } from '~/core/models'

import { ComparableCompaniesContainerComponent } from './containers'

@Component({
  selector: 'app-comparable-companies',
  templateUrl: './comparable-companies.component.html',
  styleUrl: './comparable-companies.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ComparableCompaniesContainerComponent],
})
export class ComparableCompaniesComponent {
  private readonly routerFacade = inject(RouterFacade)
  private readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  readonly guardSection = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_COMPARABLE_COMPANIES
      : EGuardSection.FORECAST_INFO_COMPARABLE_COMPANIES
  )

  constructor() {}
}
